@file:OptIn(InternalResourceApi::class)

package top.features.auth.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/top.features.auth.generated.resources/"

@delegate:ResourceContentHash(-309_225_333)
internal val Res.string.action_continue: StringResource by lazy {
      StringResource("string:action_continue", "action_continue", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10, 51),
      ))
    }

@delegate:ResourceContentHash(-1_435_543_509)
internal val Res.string.action_login: StringResource by lazy {
      StringResource("string:action_login", "action_login", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 62, 36),
      ))
    }

@delegate:ResourceContentHash(1_496_395_519)
internal val Res.string.action_register: StringResource by lazy {
      StringResource("string:action_register", "action_register", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 99, 63),
      ))
    }

@delegate:ResourceContentHash(-1_375_226_695)
internal val Res.string.back_btn: StringResource by lazy {
      StringResource("string:back_btn", "back_btn", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 163, 32),
      ))
    }

@delegate:ResourceContentHash(1_437_946_615)
internal val Res.string.error_check_data: StringResource by lazy {
      StringResource("string:error_check_data", "error_check_data", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 196, 60),
      ))
    }

@delegate:ResourceContentHash(1_022_169_772)
internal val Res.string.error_email_send_failed: StringResource by lazy {
      StringResource("string:error_email_send_failed", "error_email_send_failed", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 257, 83),
      ))
    }

@delegate:ResourceContentHash(-1_841_144_747)
internal val Res.string.error_enter_email: StringResource by lazy {
      StringResource("string:error_enter_email", "error_enter_email", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 341, 53),
      ))
    }

@delegate:ResourceContentHash(-1_455_101_709)
internal val Res.string.error_enter_phone: StringResource by lazy {
      StringResource("string:error_enter_phone", "error_enter_phone", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 395, 81),
      ))
    }

@delegate:ResourceContentHash(1_975_758_124)
internal val Res.string.error_enter_valid_lastname: StringResource by lazy {
      StringResource("string:error_enter_valid_lastname", "error_enter_valid_lastname", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 477, 98),
      ))
    }

@delegate:ResourceContentHash(-156_072_688)
internal val Res.string.error_enter_valid_name: StringResource by lazy {
      StringResource("string:error_enter_valid_name", "error_enter_valid_name", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 576, 86),
      ))
    }

@delegate:ResourceContentHash(-665_181_070)
internal val Res.string.error_invalid_code: StringResource by lazy {
      StringResource("string:error_invalid_code", "error_invalid_code", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 663, 58),
      ))
    }

@delegate:ResourceContentHash(962_920_847)
internal val Res.string.error_invalid_email_format: StringResource by lazy {
      StringResource("string:error_invalid_email_format", "error_invalid_email_format", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 722, 74),
      ))
    }

@delegate:ResourceContentHash(-887_415_876)
internal val Res.string.error_invalid_phone_format: StringResource by lazy {
      StringResource("string:error_invalid_phone_format", "error_invalid_phone_format", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 797, 98),
      ))
    }

@delegate:ResourceContentHash(-2_114_237_551)
internal val Res.string.error_login_failed: StringResource by lazy {
      StringResource("string:error_login_failed", "error_login_failed", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 896, 62),
      ))
    }

@delegate:ResourceContentHash(1_313_744_227)
internal val Res.string.error_registration_failed: StringResource by lazy {
      StringResource("string:error_registration_failed", "error_registration_failed", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 959, 81),
      ))
    }

@delegate:ResourceContentHash(1_645_456_524)
internal val Res.string.error_sms_send_failed: StringResource by lazy {
      StringResource("string:error_sms_send_failed", "error_sms_send_failed", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1041, 81),
      ))
    }

@delegate:ResourceContentHash(-1_374_101_804)
internal val Res.string.hero_subtitle: StringResource by lazy {
      StringResource("string:hero_subtitle", "hero_subtitle", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1123, 325),
      ))
    }

@delegate:ResourceContentHash(-1_237_922_749)
internal val Res.string.hero_title: StringResource by lazy {
      StringResource("string:hero_title", "hero_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1449, 106),
      ))
    }

@delegate:ResourceContentHash(859_675_006)
internal val Res.string.label_email: StringResource by lazy {
      StringResource("string:label_email", "label_email", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1629, 63),
      ))
    }

@delegate:ResourceContentHash(859_678_478)
internal val Res.string.label_email_required: StringResource by lazy {
      StringResource("string:label_email_required", "label_email_required", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1556, 72),
      ))
    }

@delegate:ResourceContentHash(-1_055_231_298)
internal val Res.string.label_firstname: StringResource by lazy {
      StringResource("string:label_firstname", "label_firstname", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1693, 35),
      ))
    }

@delegate:ResourceContentHash(1_055_240_358)
internal val Res.string.label_lastname: StringResource by lazy {
      StringResource("string:label_lastname", "label_lastname", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1729, 46),
      ))
    }

@delegate:ResourceContentHash(1_962_512_428)
internal val Res.string.label_phone: StringResource by lazy {
      StringResource("string:label_phone", "label_phone", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1845, 55),
      ))
    }

@delegate:ResourceContentHash(1_078_017_096)
internal val Res.string.label_phone_required: StringResource by lazy {
      StringResource("string:label_phone_required", "label_phone_required", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1776, 68),
      ))
    }

@delegate:ResourceContentHash(1_098_982_389)
internal val Res.string.login_choose_method: StringResource by lazy {
      StringResource("string:login_choose_method", "login_choose_method", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1901, 79),
      ))
    }

@delegate:ResourceContentHash(-627_688_652)
internal val Res.string.login_title: StringResource by lazy {
      StringResource("string:login_title", "login_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1981, 31),
      ))
    }

@delegate:ResourceContentHash(2_099_150_248)
internal val Res.string.login_verify_subtitle: StringResource by lazy {
      StringResource("string:login_verify_subtitle", "login_verify_subtitle", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2013, 173),
      ))
    }

@delegate:ResourceContentHash(1_991_497_329)
internal val Res.string.login_welcome: StringResource by lazy {
      StringResource("string:login_welcome", "login_welcome", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2187, 61),
      ))
    }

@delegate:ResourceContentHash(859_675_006)
internal val Res.string.method_email: StringResource by lazy {
      StringResource("string:method_email", "method_email", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2249, 64),
      ))
    }

@delegate:ResourceContentHash(1_962_512_428)
internal val Res.string.method_phone: StringResource by lazy {
      StringResource("string:method_phone", "method_phone", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2314, 56),
      ))
    }

@delegate:ResourceContentHash(2_125_539_842)
internal val Res.string.placeholder_firstname: StringResource by lazy {
      StringResource("string:placeholder_firstname", "placeholder_firstname", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2371, 45),
      ))
    }

@delegate:ResourceContentHash(-2_083_774_096)
internal val Res.string.placeholder_lastname: StringResource by lazy {
      StringResource("string:placeholder_lastname", "placeholder_lastname", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2417, 40),
      ))
    }

@delegate:ResourceContentHash(-717_714_031)
internal val Res.string.reg_step_1_subtitle: StringResource by lazy {
      StringResource("string:reg_step_1_subtitle", "reg_step_1_subtitle", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2458, 159),
      ))
    }

@delegate:ResourceContentHash(-1_211_763_890)
internal val Res.string.reg_step_1_title: StringResource by lazy {
      StringResource("string:reg_step_1_title", "reg_step_1_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2618, 76),
      ))
    }

@delegate:ResourceContentHash(-838_111_442)
internal val Res.string.reg_step_2_subtitle: StringResource by lazy {
      StringResource("string:reg_step_2_subtitle", "reg_step_2_subtitle", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2695, 151),
      ))
    }

@delegate:ResourceContentHash(-1_074_806_001)
internal val Res.string.reg_step_2_title: StringResource by lazy {
      StringResource("string:reg_step_2_title", "reg_step_2_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2847, 96),
      ))
    }

@delegate:ResourceContentHash(985_763_185)
internal val Res.string.reg_step_3_subtitle: StringResource by lazy {
      StringResource("string:reg_step_3_subtitle", "reg_step_3_subtitle", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2944, 187),
      ))
    }

@delegate:ResourceContentHash(-2_059_225_797)
internal val Res.string.reg_step_3_title: StringResource by lazy {
      StringResource("string:reg_step_3_title", "reg_step_3_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3132, 100),
      ))
    }

@delegate:ResourceContentHash(-627_688_652)
internal val Res.string.tab_login: StringResource by lazy {
      StringResource("string:tab_login", "tab_login", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3233, 29),
      ))
    }

@delegate:ResourceContentHash(1_481_209_044)
internal val Res.string.tab_registration: StringResource by lazy {
      StringResource("string:tab_registration", "tab_registration", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3263, 52),
      ))
    }

@delegate:ResourceContentHash(-1_716_874_552)
internal val Res.string.toast_email_resent: StringResource by lazy {
      StringResource("string:toast_email_resent", "toast_email_resent", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3316, 90),
      ))
    }

@delegate:ResourceContentHash(2_065_976_993)
internal val Res.string.toast_sms_resent: StringResource by lazy {
      StringResource("string:toast_sms_resent", "toast_sms_resent", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3407, 88),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString0Resources(map: MutableMap<String, StringResource>) {
  map.put("action_continue", Res.string.action_continue)
  map.put("action_login", Res.string.action_login)
  map.put("action_register", Res.string.action_register)
  map.put("back_btn", Res.string.back_btn)
  map.put("error_check_data", Res.string.error_check_data)
  map.put("error_email_send_failed", Res.string.error_email_send_failed)
  map.put("error_enter_email", Res.string.error_enter_email)
  map.put("error_enter_phone", Res.string.error_enter_phone)
  map.put("error_enter_valid_lastname", Res.string.error_enter_valid_lastname)
  map.put("error_enter_valid_name", Res.string.error_enter_valid_name)
  map.put("error_invalid_code", Res.string.error_invalid_code)
  map.put("error_invalid_email_format", Res.string.error_invalid_email_format)
  map.put("error_invalid_phone_format", Res.string.error_invalid_phone_format)
  map.put("error_login_failed", Res.string.error_login_failed)
  map.put("error_registration_failed", Res.string.error_registration_failed)
  map.put("error_sms_send_failed", Res.string.error_sms_send_failed)
  map.put("hero_subtitle", Res.string.hero_subtitle)
  map.put("hero_title", Res.string.hero_title)
  map.put("label_email", Res.string.label_email)
  map.put("label_email_required", Res.string.label_email_required)
  map.put("label_firstname", Res.string.label_firstname)
  map.put("label_lastname", Res.string.label_lastname)
  map.put("label_phone", Res.string.label_phone)
  map.put("label_phone_required", Res.string.label_phone_required)
  map.put("login_choose_method", Res.string.login_choose_method)
  map.put("login_title", Res.string.login_title)
  map.put("login_verify_subtitle", Res.string.login_verify_subtitle)
  map.put("login_welcome", Res.string.login_welcome)
  map.put("method_email", Res.string.method_email)
  map.put("method_phone", Res.string.method_phone)
  map.put("placeholder_firstname", Res.string.placeholder_firstname)
  map.put("placeholder_lastname", Res.string.placeholder_lastname)
  map.put("reg_step_1_subtitle", Res.string.reg_step_1_subtitle)
  map.put("reg_step_1_title", Res.string.reg_step_1_title)
  map.put("reg_step_2_subtitle", Res.string.reg_step_2_subtitle)
  map.put("reg_step_2_title", Res.string.reg_step_2_title)
  map.put("reg_step_3_subtitle", Res.string.reg_step_3_subtitle)
  map.put("reg_step_3_title", Res.string.reg_step_3_title)
  map.put("tab_login", Res.string.tab_login)
  map.put("tab_registration", Res.string.tab_registration)
  map.put("toast_email_resent", Res.string.toast_email_resent)
  map.put("toast_sms_resent", Res.string.toast_sms_resent)
}
